import {
  Group,
  Portal,
  Root as DropdownMenuRoot
} from '@radix-ui/react-dropdown-menu'
import React from 'react'

import { DropdownMenuContent } from './DropdownMenuContent'
import { DropdownMenuItem } from './DropdownMenuItem'
import { DropdownMenuLabel } from './DropdownMenuLabel'
import { DropdownMenuLinkItem } from './DropdownMenuLinkItem'
import { DropdownMenuSeparator } from './DropdownMenuSeparator'
import { DropdownMenuTrigger } from './DropdownMenuTrigger'

export const DropdownMenu = Object.assign(DropdownMenuRoot, {
  Content: DropdownMenuContent,
  Group: Group,
  Item: DropdownMenuItem,
  Label: DropdownMenuLabel,
  LinkItem: DropdownMenuLinkItem,
  Portal: Portal,
  Separator: DropdownMenuSeparator,
  Trigger: DropdownMenuTrigger
})
